import {
    fetchDelete,
    fetchGet,
    fetchPost,
    fetchPostFile,
} from '~utilities/fetch';
import ILoanDrawdownCondition from './ILoanDrawdownCondition';
import {
    transformLoanDrawdownCondition,
} from './transformers';

export async function loanDrawdownConditionsListRequest(drawdownUuid: string): Promise<Response> {
    return fetchGet(`/loan-drawdowns/${drawdownUuid}/conditions`);
}

export async function loanDrawdownConditionsAddRequest(drawdownUuid: string, loanDrawdownCondition: ILoanDrawdownCondition): Promise<Response> {
    return fetchPost(`/loan-drawdowns/${drawdownUuid}/conditions`, transformLoanDrawdownCondition(loanDrawdownCondition));
}

export async function loanDrawdownConditionDeleteRequest(loanDrawdownConditionUuid: string): Promise<Response> {
    return fetchDelete(`/loan-drawdown-conditions/${loanDrawdownConditionUuid}`);
}

export async function loanDrawdownConditionDocumentsListRequest(drawdownUuid: string): Promise<Response> {
    return fetchGet(`/loan-drawdowns/${drawdownUuid}/condition-documents`);
}

export async function loanDrawdownConditionDocumentsAddRequest(loanDrawdownConditionUuid: string, file: File): Promise<Response> {
    return fetchPostFile(`/loan-drawdown-conditions/${loanDrawdownConditionUuid}/documents`, file);
}

export async function loanDrawdownConditionDocumentDeleteRequest(loanDrawdownConditionDocumentUuid: string): Promise<Response> {
    return fetchDelete(`/loan-drawdown-condition-documents/${loanDrawdownConditionDocumentUuid}`);
}

export async function loanDrawdownConditionSuggestionsListRequest(loanDrawdownUuid: string): Promise<Response> {
    return fetchGet(`/loan-drawdowns/${loanDrawdownUuid}/condition-suggestions`);
}